export const SHI_COM_PROD_BASE_URL = "https://www.shi.com";
export const SHI_COM_NON_PROD_BASE_URL = "https://dev.shi.com";

/**
 * Returns the SHI.com base URL, prioritizing explicit `SHICOM_BASE_URL` env var over `DIST_ENV` check.
 */
export function getShiComBaseUrl(): string {
  const explicitUrl = import.meta.env.SHICOM_BASE_URL;
  if (explicitUrl) {
    return explicitUrl;
  }
  const isProd = import.meta.env.DIST_ENV === "prod";
  return isProd ? SHI_COM_PROD_BASE_URL : SHI_COM_NON_PROD_BASE_URL;
}

/**
 * Navigates to a path on SHI.com via full page redirect.
 * 
 * @param path - The URL path relative to SHI.com base (e.g., "/quote/123" or "quote/123").
 *               Leading slash is automatically added if missing.
 * 
 * @example
 * navigateToShiCom("/products"); // → https://www.shi.com/products
 * navigateToShiCom("products");  // → https://www.shi.com/products (slash auto-added)
 */
export const navigateToShiCom = (path: string) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  window.location.href = `${getShiComBaseUrl()}${normalizedPath}`;
};

